/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The heatmap is generated in your browser and your data never leaves your device.`)
};

const es_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El mapa de calor se genera en tu navegador y tus datos nunca salen de tu dispositivo.`)
};

const de_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die Heatmap wird in Ihrem Browser erstellt, und Ihre Daten verlassen Ihr Gerät nie.`)
};

const nl_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De heatmap wordt in je browser gegenereerd en je data verlaat nooit je apparaat.`)
};

const fr_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La carte de chaleur est générée dans votre navigateur et vos données ne quittent jamais votre appareil.`)
};

const it_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La mappa di calore viene generata nel tuo browser e i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O mapa de calor é gerado no seu navegador e seus dados nunca saem do seu dispositivo.`)
};

const pt_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O mapa de calor é gerado no seu navegador e os seus dados nunca saem do seu dispositivo.`)
};

const ja_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ヒートマップはブラウザ内で生成され、データが端末から外部に送信されることはありません。`)
};

const zh_heat_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。热力图在你的浏览器中生成，你的数据不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_a4", locale)
	if (locale === "en") return en_heat_faq_a4(inputs)
	if (locale === "es") return es_heat_faq_a4(inputs)
	if (locale === "de") return de_heat_faq_a4(inputs)
	if (locale === "nl") return nl_heat_faq_a4(inputs)
	if (locale === "fr") return fr_heat_faq_a4(inputs)
	if (locale === "it") return it_heat_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_a4(inputs)
	if (locale === "pt") return pt_heat_faq_a4(inputs)
	if (locale === "ja") return ja_heat_faq_a4(inputs)
	return zh_heat_faq_a4(inputs)
};